import React, { useContext } from "react";

import { darken } from "polished";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import breakpoints from "../../constants";
import Markdown from "../../styles/Markdown";
import BrowseAllVacancies from "../BrowseAllVacancies/BrowseAllVacancies";

const StyledNoVacancies = styled.div`
  background-color: ${({ backgroundColor }) =>
    darken(0.04, `${backgroundColor || "#fff"}`)};
  color: ${({ textColour }) => textColour || "inherit"};
`;

const StyledNoVacanciesWrapper = styled.div`
  overflow: auto;

  @media (min-width: ${breakpoints.DESKTOP}) {
    min-height: 450px;
    max-height: 95vh;
  }
`;

function NoVacancies() {
  const {
    backgroundColor,
    additionalConfig,
    noJobsText,
    noJobsFoundTextColour,
    noJobsFoundButtonColour,
    noJobsFoundButtonHoverColour,
    noJobsFoundButtonTextColour,
  } = useContext(ComponentContext);

  if (noJobsText) {
    return (
      <StyledNoVacanciesWrapper className="d-flex align-items-center justify-content-center no-jobs-wrapper">
        <StyledNoVacancies
          backgroundColor={backgroundColor}
          textColour={noJobsFoundTextColour}
          className="w-100 d-flex flex-column justify-content-center p-5 text-center"
        >
          <Markdown>{noJobsText}</Markdown>
        </StyledNoVacancies>
      </StyledNoVacanciesWrapper>
    );
  }

  return (
    <StyledNoVacanciesWrapper className="d-flex align-items-center justify-content-center no-jobs-wrapper">
      <StyledNoVacancies
        backgroundColor={backgroundColor}
        textColour={noJobsFoundTextColour}
        className="w-100 d-flex flex-column justify-content-center p-5 text-center"
      >
        <h3 className="mb-3">No jobs found</h3>
        <div className="mb-3">We don’t have any vacancies at the moment…</div>
        {!additionalConfig?.disableClearFilters && (
          <BrowseAllVacancies
            buttonColour={noJobsFoundButtonColour}
            buttonHoverColour={noJobsFoundButtonHoverColour}
            buttonTextColour={noJobsFoundButtonTextColour}
          />
        )}
      </StyledNoVacancies>
    </StyledNoVacanciesWrapper>
  );
}

export default NoVacancies;
